import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { constants } from '../../constants';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected readonly appVersionCode = constants.appVersionCode;
  protected isMortgageSimulator = false;
  @Input() set url(url: string | undefined) {
    this.isMortgageSimulator = !!url?.startsWith('/mortgage-simulator');
  }
}